// Single source of truth for constants - imports from shared JSON file
import constantsData from '../constants.json';

// Flatten shared and frontend constants for easy access
const sharedConstants = constantsData.shared;
const frontendConstants = constantsData.frontend;

// Re-export all shared constants
export const GRID_SIZE = sharedConstants.GRID_SIZE;
export const GRID_WIDTH = sharedConstants.GRID_WIDTH;
export const GRID_HEIGHT = sharedConstants.GRID_HEIGHT;
export const CANVAS_WIDTH = sharedConstants.CANVAS_WIDTH;
export const CANVAS_HEIGHT = sharedConstants.CANVAS_HEIGHT;
export const PLAYER_WIDTH = sharedConstants.PLAYER_WIDTH;
export const PLAYER_HEIGHT = sharedConstants.PLAYER_HEIGHT;
export const PLAYER_RADIUS_X = sharedConstants.PLAYER_RADIUS_X;
export const PLAYER_RADIUS_Y = sharedConstants.PLAYER_RADIUS_Y;
export const PLAYER_HITBOX_RADIUS = sharedConstants.PLAYER_HITBOX_RADIUS;
export const PLAYER_COLORS = sharedConstants.PLAYER_COLORS;
export const DEFAULT_EXPLOSION_RADIUS = sharedConstants.DEFAULT_EXPLOSION_RADIUS;
export const DEFAULT_MAX_BOMBS = sharedConstants.DEFAULT_MAX_BOMBS;
export const DEFAULT_SPEED = sharedConstants.DEFAULT_SPEED;
export const BOMB_KICK_SPEED = sharedConstants.BOMB_KICK_SPEED;
export const BOMB_TIMER_MS = sharedConstants.BOMB_TIMER_MS;
export const EXPLOSION_DURATION_MS = sharedConstants.EXPLOSION_DURATION_MS;
export const CENTER_TOLERANCE = sharedConstants.CENTER_TOLERANCE;
export const CORNER_CUT_DISTANCE = sharedConstants.CORNER_CUT_DISTANCE;
export const TILE_SIZE = sharedConstants.TILE_SIZE;
export const NETWORK_UPDATE_INTERVAL = sharedConstants.NETWORK_UPDATE_INTERVAL;
export const RENDER_DELAY = sharedConstants.RENDER_DELAY;
export const SNAP_THRESHOLD = sharedConstants.SNAP_THRESHOLD;
export const UPGRADE_DROP_CHANCE = sharedConstants.UPGRADE_DROP_CHANCE;
export const UPGRADE_WEIGHTS = sharedConstants.UPGRADE_WEIGHTS;
export const ANIMATION_BASE_INTERVAL = sharedConstants.ANIMATION_BASE_INTERVAL;
export const ANIMATION_TIMEOUT = sharedConstants.ANIMATION_TIMEOUT;
export const LOBBY_COUNTDOWN_DURATION = sharedConstants.LOBBY_COUNTDOWN_DURATION;
export const GAME_OVER_COUNTDOWN_DURATION = sharedConstants.GAME_OVER_COUNTDOWN_DURATION;
export const PLAYER_SPAWN_POSITIONS = sharedConstants.PLAYER_SPAWN_POSITIONS;
export const PLAYER_SPAWN_AREAS = sharedConstants.PLAYER_SPAWN_AREAS;
export const PLAYER_COLLISION_RADIUS = sharedConstants.PLAYER_COLLISION_RADIUS;
export const BOMB_PLAYER_COLLISION_DISTANCE = sharedConstants.BOMB_PLAYER_COLLISION_DISTANCE;

// Re-export frontend-specific constants
export const BOMB_SOUNDS = frontendConstants.BOMB_SOUNDS;
export const BOMB_DROP_SOUNDS = frontendConstants.BOMB_DROP_SOUNDS;
export const BOMB_KICK_SOUNDS = frontendConstants.BOMB_KICK_SOUNDS;
export const BOMB_STOP_SOUNDS = frontendConstants.BOMB_STOP_SOUNDS;
export const BOMB_BOUNCE_SOUNDS = frontendConstants.BOMB_BOUNCE_SOUNDS;
export const UPGRADE_PICKUP_SOUNDS = frontendConstants.UPGRADE_PICKUP_SOUNDS;
export const SUDDEN_DEATH_START_SOUND = frontendConstants.SUDDEN_DEATH_START_SOUND;
export const SUDDEN_DEATH_BLOCK_SOUNDS = frontendConstants.SUDDEN_DEATH_BLOCK_SOUNDS;
export const OST_TRACKS = frontendConstants.OST_TRACKS;
export const ALL_SOUNDS = frontendConstants.ALL_SOUNDS;